//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default {
	data() {
		return {
			phone: '',
			code: '',
			isPhoneError: false,
			count: '',
			placeholder: '',
			btn: '',
			content: '发送验证码',
			loading: false,
			totalTime: 60,
			canClick: true, // 添加canClick
			iconShow: false
		}
	},
	components: {
		uniIcons
	},
	watch: {
		'phone': {
			handler(val, old) {
				if (val.length > 0) {
					this.isPhoneError = this.testPhone(val)
					this.iconShow = true
				} else {
					this.iconShow = false
				}
			}
		}
	},
	onLoad(event) {
		this.btn = event.phone ? '确认更换' : '立即绑定'
		this.placeholder = event.phone ? '请输入新的手机号' : '请输入手机号'
		uni.setNavigationBarTitle({
			title: event.phone ? '更换手机号' : '绑定手机号'
		})
		this.queryData()
	},
	methods: {
		myPhone(e) {
			this.phone = e.target.value
		},
		myCode(e) {
			this.code = e.target.value
		},
		//内容清空
		clearContent() {
			this.phone = ''
		},
		//获取信息
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/member/queryById',
				data: {
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.phone = res.data.phone
			})
		},
		//获取验证码
		getCode() {
			if (this.phone && this.testPhone()) {
				this.$ajax({
					url: '/weChat/member/sendCode',
					method: 'post',
					data: {
						phone: this.phone
					}
				}).then(res => {
					if (!this.canClick) {
						this.canClick = false
						this.content = this.totalTime + 's后重新发送'
					}
					let clock = setInterval(() => {
						this.totalTime--
						this.content = this.totalTime + 's后重新发送'
						if (this.totalTime < 0) {
							clearInterval(clock)
							this.content = '发送验证码'
							this.totalTime = 60
							this.canClick = true
						}
					}, 1000)
				})
			} else if (!this.phone || !this.testPhone()) {
				uni.showToast({
					title: '请输入手机号且注意格式是否正确!',
					icon: 'none'
				})
			}
		},
		testPhone() {
			return /^1[345789]\d{9}$/.test(this.phone)
		},
		//更新
		update() {
			if (this.code) {
				this.$ajax({
					method: 'post',
					url: '/weChat/member/bindPhone',
					data: {
						phone: this.phone,
						memberId: this.$store.state.userInfo.memberId,
						code: this.code
					}
				}).then(res => {
					if(res.errCode===8200){
						this.$ajax({
						  method: 'post',
						  url: '/weChat/member/updateById',
						  data: {
						    phone: this.phone,
						    memberId: this.$store.state.userInfo.memberId
						  }
						}).then(res=>{
							uni.showModal({
								title:'提示',
								content: '恭喜您,绑定成功',
								showCancel:false,
								success(res) {
									if (res.confirm) {
										uni.navigateBack({
											delta:1
										})
									}
								}
							})
						})
					}
				})
			} else {
				uni.showToast({
					title: '请输入验证码!',
					icon: 'none'
				})
			}
		}
	}
}
